import React, { useEffect, useState } from 'react';
import { api } from '../../api';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Download, Image as ImageIcon, FileVideo, Loader2, Send } from 'lucide-react';
import { buildFileUrl } from '../../lib/files';

export default function ClientGallery() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get('/gallery/mine').then(r => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className='p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto'>
      <div className='mb-5'>
        <div className='text-[10px] uppercase tracking-[0.16em] font-bold text-[#C8102E]'>From your JFK9 trainers</div>
        <h1 className='font-display text-2xl sm:text-3xl font-bold text-slate-900 dark:text-slate-50 mt-1'>My Gallery</h1>
        <p className='text-sm text-slate-500 dark:text-slate-400 mt-1'>Photos and videos your trainers and the JFK9 team have shared with you.</p>
      </div>
      {loading ? (
        <Card className='p-10 text-center text-slate-500'><Loader2 className='w-4 h-4 animate-spin inline mr-2' /> Loading…</Card>
      ) : items.length === 0 ? (
        <Card className='p-10 text-center text-slate-500 dark:text-slate-400 bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-800'>
          <Send className='w-10 h-10 mx-auto text-slate-300 dark:text-slate-700 mb-2' />
          No media yet. Your trainers will post photos and videos here.
        </Card>
      ) : (
        <div className='grid sm:grid-cols-2 lg:grid-cols-3 gap-4'>
          {items.map((it) => {
            const url = buildFileUrl(it.file.url || it.file.id);
            const isVideo = it.file.content_type?.startsWith('video/');
            return (
              <Card key={it.id} className='border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 overflow-hidden flex flex-col' data-testid={`gallery-item-${it.id}`}>
                <div className='aspect-video bg-slate-100 dark:bg-slate-950'>
                  {isVideo
                    ? <video src={url} controls preload='metadata' className='w-full h-full object-contain bg-black' />
                    : <img src={url} alt={it.title || ''} className='w-full h-full object-cover' />}
                </div>
                <div className='p-3.5 flex-1 flex flex-col'>
                  <Badge className='bg-[#1B3A87]/15 text-[#1B3A87] dark:text-[#93C5FD] border-0 w-fit text-[10px]'>
                    {isVideo ? <FileVideo className='w-3 h-3 mr-1' /> : <ImageIcon className='w-3 h-3 mr-1' />}
                    {it.audience}
                  </Badge>
                  {it.title && <div className='font-display font-bold text-sm text-slate-900 dark:text-slate-50 mt-1.5'>{it.title}</div>}
                  {it.caption && <div className='text-xs text-slate-600 dark:text-slate-300 mt-1'>{it.caption}</div>}
                  <div className='mt-3 flex items-center justify-between text-[11px] text-slate-500 dark:text-slate-400'>
                    <span>{it.sender_name} · {new Date(it.created_at).toLocaleDateString()}</span>
                    <a href={url} target='_blank' rel='noopener noreferrer' className='inline-flex items-center gap-1 text-[#1B3A87] dark:text-[#93C5FD] hover:underline' data-testid={`gallery-download-${it.id}`}>
                      <Download className='w-3.5 h-3.5' /> Download
                    </a>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
